import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useCallback } from 'react';
import DialogWaitingListRequest from '@/components/dialog/DialogWaitingListRequest';
import MainSection from '@/components/page/home/MainSection';
import PartnerSection from '@/components/page/home/PartnerSection';
import QnaSection from '@/components/page/home/QnaSection';
import UsageSection from '@/components/page/home/UsageSection';
import UtilizeSection from '@/components/page/home/UtilizeSection';
import useOpen from '@/hooks/useOpen';

export default function Home() {
  // open
  const {
    value: isShowWaitingListRequest,
    handleClose: onWaitingListRequestClose,
  } = useOpen({ defaultValue: true });

  // callback
  const handleWaitingListRequestClose = useCallback(() => {
    onWaitingListRequestClose();
  }, [onWaitingListRequestClose]);

  return (
    <>
      <MainSection />
      <UsageSection />
      <UtilizeSection />
      <PartnerSection />
      <QnaSection />

      <DialogWaitingListRequest
        isShow={isShowWaitingListRequest}
        onDimClick={handleWaitingListRequestClose}
        onCloseClick={handleWaitingListRequestClose}
      />
    </>
  );
}

export const getStaticProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      'common',
      'dialog',
      'tooltip',
      'preset',
      'home',
    ])),
  },
});
